<template>
  <div>
    <img v-if="accountId != null && Boolean(hasImg)" :src="imgUrl" :alt="accountName">
    <img v-else-if="accountId != null && !Boolean(hasImg)" :src="noUserIcon" :alt="accountName">
  </div>
</template>
<script setup>
import Global from '@/js/constant.js'
import Common from '@/js/common.js'
import { computed, defineProps } from "vue"

// --- props ---
let props = defineProps({
  hasImg: {
    type: Boolean,
    required: true
  },
  accountId: {
    type: Number,
    required: false
  },
  accountName: {
    type: String,
    required: false
  },
})

// --- computed ---
const imgUrl = computed(() => `/app/images/account/${props.accountId}`)
const noUserIcon = computed(() => `${Common.getBaseUrl()}${Global.static_path}/images/common/user_icon.png`)
</script>